import { render } from "./BuyEducations.vue?vue&type=template&id=551d126e&scoped=true"
import script from "./BuyEducations.vue?vue&type=script&lang=js"
export * from "./BuyEducations.vue?vue&type=script&lang=js"

import "./BuyEducations.vue?vue&type=style&index=0&id=551d126e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551d126e"]])

export default __exports__